import { addDoc, collection, doc, getDocs, getFirestore, query, updateDoc, where } from "@firebase/firestore";
import { CoachNoteType } from "../Types/coachNotes";
import { userType } from "../Types/user";

export async function fetchAddCoachNote(userData: Partial<CoachNoteType>) {
    const userRef = collection(getFirestore(), "coach_notes");
    await addDoc(userRef, userData);
  }

